<template>
    <div class="tabs_menu">
      <div class="menus" ref="menusContainer">
        <template  v-for="(menu,index) in menus">
          <div class="menu_item" ref="menuItems" :class="{active:index == active}" @click="changeActive(menu,index)">
            <a-badge :count="countNumbers[menu.name]" :offset="[12,-1]">
              <span ref="menuItemSpans" class="menu_item_span">{{$t(menu.meta.title)}}</span>
            </a-badge>
          </div>
        </template>
        <div class="ant-tabs-ink-bar ant-tabs-ink-bar-animated tabs_menu_line" :style="lineStyle"></div>
      </div>

    </div>
</template>

<script>
  import { TOP_ACTIVE_MENU } from '@/store/mutation-types'
  import { mapState, mapActions } from 'vuex'
  import Api from '@/api/mine/todo'
  import dealConfirmApi from '@/api/mine/dealConfirm'
  import financialApi from '@/api/database/financial'

  import menu from '../Menu/menu'
  export default {
    name: 'index',
    data(){
      return {
        menus:[],
        active:0,
        countNumbers:{

        },
        lineStyle:{
          transform: 'translate3d(0, 0, 0)',
          width: '0px',
          height: '4px',
          display: 'block'
        }
      }
    },
    computed:{
      ...mapState({
        // 动态主路由
        mainMenu: state => state.permission.addRouters,
        flushIndex: state => state.permission.flushIndex
      }),
      style(){
        let widht = this.active*110+40;
        return `transform: translate3d(${widht}px, 0px, 0px);width: 30px; height: 4px;display: block;`
      }
    },
    watch:{
      flushIndex(oldValue,newValue){
        console.log("索引值发生变化")
        this.getFinancialNumber();
      },
      '$i18n.locale'() {
        this.$nextTick(() => {
          this.updateLineStyle()
        })
      }
    },
    mounted(){
      this.getFinancialNumber();
    },
    methods:{
      ...mapActions(['SetleftRouters']),
      updateLineStyle() {
        this.$nextTick(() => {
          const container = this.$refs.menusContainer
          const spans = this.$refs.menuItemSpans
          const activeSpan = Array.isArray(spans)
            ? spans[this.active]
            : spans

          if (!container || !activeSpan) {
            return
          }

          const containerRect = container.getBoundingClientRect()
          const spanRect = activeSpan.getBoundingClientRect()

          const lineWidth = 30

          const left =
            spanRect.left -
            containerRect.left +
            (spanRect.width - lineWidth) / 2
          this.lineStyle = {
            width: `${lineWidth}px`,
            transform: `translate3d(${left}px, 0, 0)`,
            height: '4px',
            display: 'block'
          }
        })
      },
      initNumber(){
        Api.todoList({current:1}).then(res=>{
          if(res.code == 1){
            this.initMenu(res.data.total)
          }
        })
      },
      getFinancialNumber(){
        financialApi.getFinancialNumber().then(res=>{
          if(res.code == 1){
              this.countNumbers = res.data;
            this.initNumber()
          }
        })
      },
      initDealConfirmNum(){
        dealConfirmApi.dealConfirmStatistic().then(res=>{
          if(res.code == 1){
            let number = res.data
            this.menus = this.mainMenu.find(item => item.path === '/').children
            this.menus[0].children.forEach((data,index)=>{
              if(data.name == 'Commission'){
                this.$set(this.menus[0].children[index].meta,'count',number.confirmCount + number.debtsCount + number.rejectedCount)
              }
            })
          }
        })
      },
      initMenu(todoTotal){
        let active = this.$ls.get(TOP_ACTIVE_MENU)
        this.menus = this.mainMenu.find(item => item.path === '/').children
        this.menus[0].children.forEach((data,index)=>{
          if(data.name == 'Approval'){
            this.$set(this.menus[0].children[index].meta,'count',todoTotal)
            this.$set(this.menus[0].children[index].children[0].meta,'count',todoTotal)
          }
        })
        console.log(this.menus)
        if(active){
          if(active > this.menus.length -1 ){
            this.active = 0
            this.changeActive(this.menus[0],0)
          }else{
            this.active = active
            this.firstActive(this.menus[active],active,true)
          }

        }else{
          this.active = 0
          this.firstActive(this.menus[0],0,true)
        }
        this.$nextTick(() => {
          this.updateLineStyle()
        })
      },
      firstActive(menu,index,flag){
        if(menu.children[0] && !flag){
          this.$router.push({path:menu.children[0].path})
        }
        this.active = index
        menu.children.forEach((data,index)=>{
          if(this.countNumbers[data.name] != undefined){
            this.$set(menu.children[index].meta,'count',this.countNumbers[data.name])
          }
          if(data.children && data.children.length > 0){
            data.children.forEach((menuData,index2)=>{
              if(menuData.name == 'Approval'){
                this.$set(menuData.children[index2].meta,'count',res.data.total)
                this.$set(menu.children[index].children[0].meta,'count',res.data.total)
              }
              console.log("改变数量",menuData.name,this.countNumbers[menuData.name],menuData)
              if(this.countNumbers[menuData.name] != undefined){

                this.$set(menu.children[index].children[index2].meta,'count',this.countNumbers[menuData.name])
              }
            })
          }
        })
        this.SetleftRouters({menu:menu.children,active:index});
        this.updateLineStyle()
      },
      changeActive(menu,index,flag){
        //点击每个tab的时候跳转到默认页面
        this.changeNumber(menu).then(()=>{
          console.log(menu)
          if(menu.children[0] && !flag){
            this.$router.push({path:menu.children[0].path})
          }
          this.active = index
          this.SetleftRouters({menu:menu.children,active:index});
          this.updateLineStyle()
          this.$forceUpdate();
        })
      },
      changeNumber(menu){
        return new Promise(resolve => {
          Api.todoList({current:1}).then(res=>{
            if(res.code == 1){
              menu.children.forEach((data,index)=>{
                if(data.name == 'Approval'){
                  this.$set(menu.children[index].meta,'count',res.data.total)
                  this.$set(menu.children[index].children[0].meta,'count',res.data.total)
                }
                console.log("改变数量",data.name,this.countNumbers[data.name],data)
                if(this.countNumbers[data.name] != undefined){

                  this.$set(menu.children[index].meta,'count',this.countNumbers[data.name])
                }
                if(data.children && data.children.length > 0){
                  data.children.forEach((menuData,index2)=>{
                    if(menuData.name == 'Approval'){
                      this.$set(menuData.children[index2].meta,'count',res.data.total)
                      this.$set(menu.children[index].children[0].meta,'count',res.data.total)
                    }
                    console.log("改变数量",menuData.name,this.countNumbers[menuData.name],menuData)
                    if(this.countNumbers[menuData.name] != undefined){

                      this.$set(menu.children[index].children[index2].meta,'count',this.countNumbers[menuData.name])
                    }
                  })
                }
              })

            }
          }).finally(()=>{
            resolve()
          })
        })

      },
    }
  }
</script>

<style scoped lang="less">
  @import "../../core/diy.less";
  .tabs_menu{
    position: relative;
    width: auto;
    height: 50px;
    user-select: none;
    .menus{
      position: relative;
      display: flex;
      align-items: center;
      height: 50px;
      .menu_item{
        flex-shrink: 0;
        padding: 0px 20px;
        color: @white;
        text-align: center;
        font-size: 16px;
        .menu_item_span{
          color: @white;
          text-align: center;
          font-size: 16px;
        }
      }
      .active{
        color: @primary-color;
      }
      .tabs_menu_line{
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: @primary-color;
        border-radius: 2px;
        transition:
          transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
          width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
    }
  }
</style>